import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../../lib/api";

export default function RoomTypeQuick() {
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    api.get("/room-types").then((r) => setRooms(r.data || [])).catch(() => {});
  }, []);

  return (
    <section className="section-pad" data-testid="room-type-quick">
      <div className="container-site">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
          <div>
            <p className="accent-script text-gold text-2xl mb-1">Benzersiz Araç</p>
            <h2 className="heading-serif text-3xl md:text-4xl font-semibold text-navy">
              Oda Tipine Göre Komple Ekipman
            </h2>
            <p className="text-gray-600 mt-2 max-w-xl">
              Her oda tipinin ekipman checklist'i ve yıldız gereksinimi — tek tıkla teklif.
            </p>
          </div>
          <Link to="/hesaplama" className="text-navy hover:text-gold flex items-center gap-1 link-underline">
            Ekipman Hesaplama <ArrowRight size={14} />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {rooms.map((r) => (
            <Link
              key={r.id}
              to={`/oda-tipleri/${r.slug}`}
              className="card-premium aspect-square p-4 flex flex-col items-center justify-center text-center group"
              data-testid={`room-quick-${r.slug}`}
            >
              {r.image && (
                <div className="h-14 w-14 rounded-full overflow-hidden mb-3 ring-2 ring-gold/30 group-hover:ring-gold transition-all">
                  <img src={r.image} alt={r.name_tr} className="h-full w-full object-cover" />
                </div>
              )}
              <div className="heading-serif text-sm font-semibold text-navy group-hover:text-gold transition-colors">
                {r.name_tr}
              </div>
              <div className="text-[10px] uppercase tracking-wider text-gray-400 mt-1">Checklist</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
